import { Link } from "react-router";
import { AmbientGlow, Logo } from "./_shared";

// Ported from Claude Design handoff (sections-rest: Footer).
// 4-col grid: logo+tagline | Navegação | Contato | Legal. Mono row at bottom.

const handleAnchorClick = (href: string) => {
  const el = document.querySelector(href);
  if (el) {
    const top = el.getBoundingClientRect().top + window.scrollY - 72;
    window.scrollTo({ top, behavior: "smooth" });
  }
};

const NAV_LINKS: Array<{ label: string; href: string }> = [
  { label: "Problema", href: "#problema" },
  { label: "Solução", href: "#solucao" },
  { label: "Como Funciona", href: "#como-funciona" },
  { label: "FAQ", href: "#faq" },
];

const linkStyle: React.CSSProperties = {
  fontSize: 14,
  color: "var(--cy-ink-80)",
  textDecoration: "none",
  background: "transparent",
  border: "none",
  padding: 0,
  cursor: "pointer",
  textAlign: "left",
  fontFamily: "var(--cy-fs-sans)",
  transition: "color .15s ease",
};

export function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      style={{
        position: "relative",
        padding: "80px 40px 40px",
        background: "var(--cy-bg)",
        borderTop: "1px solid var(--cy-ink-10)",
        overflow: "hidden",
      }}
    >
      <AmbientGlow variant="tr" intensity={0.7} />
      <div
        style={{
          position: "relative",
          zIndex: 1,
          maxWidth: 1360,
          margin: "0 auto",
        }}
      >
        <div
          className="cy-footer-grid"
          style={{
            display: "grid",
            gridTemplateColumns: "2fr 1fr 1fr 1fr",
            gap: 60,
            marginBottom: 64,
          }}
        >
          <div>
            <Logo size={28} textSize={22} />
            <div
              style={{
                marginTop: 20,
                fontSize: 14,
                lineHeight: 1.55,
                color: "var(--cy-ink-60)",
                maxWidth: 340,
              }}
            >
              Monitoramento contínuo de segurança para empresas brasileiras.
            </div>
          </div>

          {/* Navegação */}
          <div>
            <div className="cy-tape" style={{ marginBottom: 16 }}>
              Navegação
            </div>
            <ul
              style={{
                listStyle: "none",
                margin: 0,
                padding: 0,
                display: "flex",
                flexDirection: "column",
                gap: 10,
              }}
            >
              {NAV_LINKS.map((link) => (
                <li key={link.href}>
                  <button
                    onClick={() => handleAnchorClick(link.href)}
                    style={linkStyle}
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contato */}
          <div>
            <div className="cy-tape" style={{ marginBottom: 16 }}>
              Contato
            </div>
            <ul
              style={{
                listStyle: "none",
                margin: 0,
                padding: 0,
                display: "flex",
                flexDirection: "column",
                gap: 10,
              }}
            >
              <li>
                <a
                  href="mailto:support@cyphronsec.com"
                  style={{ ...linkStyle, display: "inline-block" }}
                >
                  E-mail
                </a>
              </li>
              <li>
                <button
                  onClick={() => handleAnchorClick("#contato")}
                  style={linkStyle}
                >
                  Formulário de Contato
                </button>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <div className="cy-tape" style={{ marginBottom: 16 }}>
              Legal
            </div>
            <ul
              style={{
                listStyle: "none",
                margin: 0,
                padding: 0,
                display: "flex",
                flexDirection: "column",
                gap: 10,
              }}
            >
              <li>
                <Link
                  to="/termos"
                  style={{ ...linkStyle, display: "inline-block" }}
                >
                  Termos de Uso
                </Link>
              </li>
              <li>
                <Link
                  to="/privacidade"
                  style={{ ...linkStyle, display: "inline-block" }}
                >
                  Política de Privacidade
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            paddingTop: 24,
            borderTop: "1px solid var(--cy-ink-10)",
            flexWrap: "wrap",
            gap: 12,
          }}
        >
          <span
            className="cy-mono"
            style={{ fontSize: 11, color: "var(--cy-ink-40)" }}
          >
            © {year} Cyphron. Todos os direitos reservados.
          </span>
          <span
            className="cy-mono"
            style={{ fontSize: 11, color: "var(--cy-ink-40)" }}
          >
            feito no brasil
          </span>
        </div>
      </div>
    </footer>
  );
}
